<form *ngIf="fields" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addEditForm" (ngSubmit)="saveOrUpdate(dialogBoxLanguage)" RestrictFocus>

  <div class="ui-grid ui-grid-responsive ui-fluid" >

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label [ngClass]="{'required': !fields.iso_code.nullable}">{{ fields.iso_code.keyName }}</label>
      </div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="iso_code" pInputText/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.iso_code"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label [ngClass]="{'required': !fields.nls_code.nullable}">{{ fields.nls_code.keyName }}</label>
      </div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="nls_code" pInputText/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.nls_code"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label [ngClass]="{'required': !fields.language.nullable}">{{ fields.language.keyName }}</label>
      </div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="language" pInputText/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.language"></app-validation-msg>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
              label="{{dialogBoxLanguage.id ? ('common.edit' | translate) :  ('common.add' | translate) }} {{ 'languageList.language' |translate }}"></button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/language/languageForm.html